import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { maskString } from "helpers/utils";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface IPaymentInfo {
    /**
     * Data to display (or hide) like beneficiary.iban
     */
    data: string;
    /**
     * Type of data displayed (ex: iban)
     */
    dataType: string;
    /**
     * Label of the data (also used for maskSensitiveInfo)
     */
    label: string;
    /**
     * Object with data to be hidden.
     */
    maskSensitiveInfo: { [x: string]: boolean };
    /**
     * Switches status of data in the maskSensitiveInfo object > go from true to false if you want to display data and vice-versa.
     */
    handleVisibility: (key: string) => void;
    /**
     * Number of characters to show (defaults to 3)
     */
    maskCount?: number;
}

const PaymentInfo = ({ data, dataType, maskSensitiveInfo, handleVisibility, label, maskCount }: IPaymentInfo) => {
    const [t] = useTranslation();

    return (
        <p className={styles["bank-info-masked"]}>
            <span>{`${label} : `}</span>
            <div id={`mask-${dataType}`} className={styles["mask-svg"]} onClick={() => handleVisibility(label)}>
                {data === "" || !data ? (
                    dataType === "paypal" ? (
                        "-"
                    ) : (
                        t("Payment.NotSpecified")
                    )
                ) : maskSensitiveInfo[label] ? (
                    <>
                        {maskString(data, maskCount)} <Visibility />
                    </>
                ) : (
                    <>
                        {data} <VisibilityOff />
                    </>
                )}
            </div>
        </p>
    );
};

export default PaymentInfo;
